import Mobiles_Cone_QHQS332 from './icon-images/Mobiles_Cone_QHQS332.png';
import Mobiles_Cone_QHQS332_HS_CC_1 from './icon-images/Mobiles_Cone_QHQS332_HS_CC_1.png';
import Mobiles_Cone_QHQS332_HS_CC_2 from './icon-images/Mobiles_Cone_QHQS332_HS_CC_2.png';
import Mobiles_Cone_QHQS332_HS_OC_2 from './icon-images/Mobiles_Cone_QHQS332_HS_OC_2.png';
import Mobiles_Cone_QHQS332_HS_OC_3 from './icon-images/Mobiles_Cone_QHQS332_HS_OC_3.png';
import Mobiles_Cone_QH441 from './icon-images/Mobiles_Cone_QH441.png';
import Mobiles_Cone_QH441_HS_CC from './icon-images/Mobiles_Cone_QH441_HS_CC.png';
import Mobiles_Cone_QH441_HS_OC from './icon-images/Mobiles_Cone_QH441_HS_OC.png';
import Mobiles_Cone_QH443E from './icon-images/Mobiles_Cone_QH443E.png';
import Mobiles_Cone_UH640 from './icon-images/Mobiles_Cone_UH640.png';
import Mobiles_Cone_US440i from './icon-images/Mobiles_Cone_US440i.png';
import Mobiles_Cone_US440i_HS_CC from './icon-images/Mobiles_Cone_US440i_HS_CC.png';
import Mobiles_Cone_US440i_HS_OC from './icon-images/Mobiles_Cone_US440i_HS_OC.png';
import Mobiles_Cone_UH310 from './icon-images/Mobiles_Cone_UH310.png';
import Mobiles_Cone_UH320 from './icon-images/Mobiles_Cone_UH320.png';
import Mobiles_Cone_UK373 from './icon-images/Mobiles_Cone_UK373.png';
import Mobiles_Cone_UH373 from './icon-images/Mobiles_Cone_UH373.png';
import Mobiles_Cone_UH573 from './icon-images/Mobiles_Cone_UH573.png';
import Mobiles_Cone_US373 from './icon-images/Mobiles_Cone_US373.png';
import Mobiles_Cone_US640E from './icon-images/Mobiles_Cone_US640E.png';
import { MobileUnitConeCrusherTypes } from './unitInfoData';

export const getImageMobileCone = (model: string, configKey: number) => {
  if (model === MobileUnitConeCrusherTypes.QH332) {
    switch (configKey) {
      case 0:
        return Mobiles_Cone_QHQS332;
      case 1:
        return Mobiles_Cone_QHQS332_HS_OC_2;
      case 2:
        return Mobiles_Cone_QHQS332_HS_OC_3;
      case 3:
        return Mobiles_Cone_QHQS332_HS_CC_1;
      case 4:
        return Mobiles_Cone_QHQS332_HS_CC_2;
      default:
        return Mobiles_Cone_QHQS332;
    }
  } else if (model === MobileUnitConeCrusherTypes.QH441) {
    switch (configKey) {
      case 0:
        return Mobiles_Cone_QH441;
      case 1:
        return Mobiles_Cone_QH441_HS_OC;
      case 2:
        return Mobiles_Cone_QH441_HS_CC;
      default:
        return Mobiles_Cone_QH441;
    }
  } else if (model === MobileUnitConeCrusherTypes.QH443E) {
    switch (configKey) {
      case 0:
        return Mobiles_Cone_QH443E;
      default:
        return Mobiles_Cone_QH443E;
    }
  } else if (model === MobileUnitConeCrusherTypes.QS332) {
    switch (configKey) {
      case 0:
        return Mobiles_Cone_QHQS332;
      case 1:
        return Mobiles_Cone_QHQS332_HS_OC_2;
      case 2:
        return Mobiles_Cone_QHQS332_HS_OC_3;
      case 3:
        return Mobiles_Cone_QHQS332_HS_CC_1;
      case 4:
        return Mobiles_Cone_QHQS332_HS_CC_2;
    }
  } else if (
    model === MobileUnitConeCrusherTypes.US440E ||
    model === MobileUnitConeCrusherTypes.UH440E ||
    model === MobileUnitConeCrusherTypes.UH640
  ) {
    return Mobiles_Cone_UH640;
  } else if (
    model === MobileUnitConeCrusherTypes.UH440i ||
    model === MobileUnitConeCrusherTypes.US440i
  ) {
    switch (configKey) {
      case 0:
        return Mobiles_Cone_US440i;
      case 1:
        return Mobiles_Cone_US440i_HS_OC;
      case 2:
        return Mobiles_Cone_US440i_HS_CC;
      default:
        return Mobiles_Cone_US440i;
    }
  } else if (
    model === MobileUnitConeCrusherTypes.UH311 ||
    model === MobileUnitConeCrusherTypes.UH312 ||
    model === MobileUnitConeCrusherTypes.UH412 ||
    model === MobileUnitConeCrusherTypes.UH316 ||
    model === MobileUnitConeCrusherTypes.US316
  ) {
    return Mobiles_Cone_UH310;
  } else if (model === MobileUnitConeCrusherTypes.UH320_Flex) {
    return Mobiles_Cone_UH320;
  } else if (model === MobileUnitConeCrusherTypes.UK373) {
    return Mobiles_Cone_UK373;
  } else if (model === MobileUnitConeCrusherTypes.UH373) {
    return Mobiles_Cone_UH373;
  } else if (model === MobileUnitConeCrusherTypes.UH573) {
    return Mobiles_Cone_UH573;
  } else if (model === MobileUnitConeCrusherTypes.US373) {
    return Mobiles_Cone_US373;
  } else if (model === MobileUnitConeCrusherTypes.US640E) {
    return Mobiles_Cone_US640E;
  }
  return Mobiles_Cone_QHQS332;
};
